import { observer } from 'mobx-react-lite';
import { IQuestionTypeProps } from '../question-types-props';
import ImageUploadView from '../image-upload-view/image-upload-view';
import Translation from '../../../../../../translation/translation';
import FontBody1 from '../../../../../../components/fonts/font-body1/font-body1';
import { FONT_VARIANT } from '../../../../../../components/fonts/font-props';
import ControlGroup from '../../../../../../components/layouts/control-group/control-group';
import { FormField } from '../../../../../../components/form-field/form-field';
import { SelectDropdown } from '../../../../../../components/inputs/select-dropdown/select-dropdown';
import { mediaOptionTypeList, MEDIA_OPTION_TYPE, MEDIA_OPTION_TYPE_MAP } from '../../../../constants';
import portalStore from '../../../../../../stores/current-portal-store';
import { FEATURES } from '../../../../../../models/Plan';
import FollowUpQuestionStore from '../../../../stores/follow-up-question-store';


const FuqImageRequest: React.FC<IQuestionTypeProps> = observer(({
    // DICLAIMER: before migration to React 18, it was reusing `answerDefaultProps` from question-types-props.ts
    // TODO: discuss during CR
    question = {} as FollowUpQuestionStore,
    disabled = false,
    validationGroup
}) => {
    const selectedMediaOptionType = MEDIA_OPTION_TYPE_MAP[question?.mediaOption as MEDIA_OPTION_TYPE];

    return (<>
        {disabled && <div className="answer-title">
            <Translation Font={FontBody1} variant={FONT_VARIANT.BOLD} translationKey={question?.question as string} />
            <Translation Font={FontBody1} translationKey={question?.instruction as string} />
        </div>}

        <ControlGroup>
            <ImageUploadView required={ question?.isImageRequired } />

            {portalStore.isFeatureAllowed(FEATURES.VIDEO_UPLOAD) && 
                <div className='request-media-options'>
                    <FormField label="Media Option" required>
                        <SelectDropdown
                            placeholder="Please select"
                            value={ selectedMediaOptionType }
                            options={ mediaOptionTypeList() }
                            required
                            validationGroup={ validationGroup }
                            onChange={ 
                                v => question?.setMediaOption(v?.value as MEDIA_OPTION_TYPE) 
                            }
                        />
                    </FormField>
                </div>
            }
        </ControlGroup>
    </>
    )
});

export default FuqImageRequest;
